import "@reach/dialog/styles.css"
import "@reach/menu-button/styles.css"

import { Root } from "@bigif/components/layout"

export const wrapRootElement = Root
